import { isScreenshotMode } from "@constants/common";
import { useAppStore } from "@hooks/useAppStore";
import type { CustomConfigType } from "@memorang/constants/config/schema";
import { buildBrandTheme } from "@memorang/ui/helpers/theme/brand";
import { screenshotModThemeColors } from "../../constants/screenshot-mod-theme-colors";

const theme = (
	darkMode?: boolean,
	themeOverride?: CustomConfigType["theme"],
) => {
	const state = useAppStore.getState();
	const activeTheme = themeOverride ?? state.theme;
	const themeColors = isScreenshotMode
		? screenshotModThemeColors
		: activeTheme?.colors;
	return buildBrandTheme({
		themeColors: themeColors as
			| {
					light?: Record<string, string>;
					dark?: Record<string, string>;
			  }
			| undefined,
		font: state.app?.font,
		darkMode: !!darkMode,
		roundness: state.theme?.roundness,
		appComponentOverrides: state.app?.componentOverrides as
			| Record<string, unknown>
			| undefined,
	});
};

export default theme;
